module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("T.D. Holmes is a British author based in Northern Ireland, UK. Despite being dyslexic, she loves to read and after a traumatic experience, found solace in writing. Since then, her love for writing grew as she discovered a creative and vivid imagination.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("She describes herself as nerdy with a sarcastic sense of humour. She loves everything Disney and sci-fi. From "), _c('em', [_vm._v("Doctor Who")]), _vm._v(" to "), _c('em', [_vm._v("Marvel")]), _vm._v(" and "), _c('em', [_vm._v("DC")]), _vm._v(". She has a great love of foxes and dreams to start a conservation charity.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0